import { Component, OnInit } from '@angular/core';
import { CWSMSAPIService } from '../cwsmsapi.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
	email: any = "";
	password: any = "";
	errorMessage: any = "";
	loading: boolean = false;
	resetPassword: boolean = false;
	passwordResetCodeSent: boolean = false;
	passwordResetCodeConfirmed: boolean = false;
	verificationCode: string = "";
	queryParams: any;

	constructor(public cwsms: CWSMSAPIService, public router: Router, private route: ActivatedRoute, public translate: TranslateService) {
		this.route.queryParams.subscribe(params => {
			console.log(params);
			this.queryParams = params;

			if ("error" in params) {
				this.errorMessage = params.error;
			} else {
				this.email = params['e'];
				this.password = params['p'];

				if (this.email !== undefined && this.email !== null && this.email !== "" && this.password !== "") {
					this.login();
				}
			}
		});
	}

	forgotPassword() {
		this.resetPassword = !this.resetPassword;
	}

	backToLogin() {
		this.resetPassword = false;
		this.passwordResetCodeSent = false;
		this.passwordResetCodeConfirmed = false;
	}

	sendPasswordResetCode() {
		this.loading = true;
		this.errorMessage = "";
		this.cwsms.post('/auth/reset', {
			email: this.email
		}, (err, data) => {
			this.loading = false;
			if (err) {
				this.errorMessage = this.translate.instant(err.error.message);
			} else {
				this.passwordResetCodeSent = true;
			}
		});
	}

	confirmVerificationCode() {
		this.loading = true;
		this.errorMessage = "";
		this.cwsms.post('/auth/reset/confirm', {
			email: this.email,
			cc: this.verificationCode
		}, (err, data) => {
			this.loading = false;
			if (err) {
				this.errorMessage = err.error.message;
			} else {
				this.passwordResetCodeConfirmed = true;
			}
		});
	}

	saveNewPassword() {
		this.loading = true;
		this.errorMessage = "";
		this.cwsms.post('/auth/reset/confirm', {
			email: this.email,
			cc: this.verificationCode,
			newPassword: this.password
		}, (err, data) => {
			this.loading = false;
			if (err) {
				if (err.error.message === "Invalid password") {
					this.errorMessage = this.translate.instant("The password needs to be at least 6 characters long, and must contain at least one capital letter, one small letter and one number.");
				} else {
					this.errorMessage = err.error.message;
				}
			} else {
				this.resetPassword = false;
				this.passwordResetCodeSent = false;
				this.passwordResetCodeConfirmed = false;
			}
		});
	}

	changeLanguage(lang) {
		var url = window.location.href.toString().split("?")[0];
		window.location.href = url+"?lang="+lang;
	}

	ngOnInit() {
		this.getUser();

		if (this.queryParams["lang"]) {
			this.translate.use(this.queryParams["lang"]);
		}
	}

	login() {
		this.loading = true;
		this.cwsms.post('/auth/login', {
			email: this.email,
			password: this.password
		}, (err, data) => {
			this.loading = false;
			if (err) {
				console.log(err);
				this.errorMessage = this.translate.instant(err.error.message);
			} else {
				console.log(data);
				var qp = {};
				if (this.queryParams["lang"]) {
					qp["lang"] = this.queryParams["lang"];
				}
				this.router.navigate(['home'], { queryParams: qp });
			}
		})
	}

	getUser() {
		this.loading = true;
		this.cwsms.get('/user', (err, data) => {
			this.loading = false;
			if (err) {
				console.log(err);
			} else {
				console.log(data);
				var qp = {};
				if (this.queryParams["lang"]) {
					qp["lang"] = this.queryParams["lang"];
				}
				this.router.navigate(['home'], { queryParams: qp });
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts